












import { Component, Vue, Watch } from 'vue-property-decorator';
import dxCustomStore from 'devextreme/data/custom_store';
import Card from '@/components/default/Card.vue';
import MachineryStatusTable from '@/modules/machinery/components/machineryStatusTable.vue';

@Component({
  components: {
    Card,
    MachineryStatusTable,
  },
})
export default class MachineryStatusOverviewPage extends Vue {
  // Empty
}
